import React from 'react'
import { Word } from './Word'
import { WordState, HideWordMode, ShowWordMode } from '../types'

interface WordGridProps {
	lines: WordState[][];
	hideWordMode: HideWordMode;
	showWordMode: ShowWordMode;
	onWordToggle: (wordId: string) => void;
	fontSize?: number;
}

export const WordGrid: React.FC<WordGridProps> = ({
	lines,
	hideWordMode,
	showWordMode,
	onWordToggle,
	fontSize = 48,
}) => {
	const urlParams = new URLSearchParams(window.location.search)
	const isDisplayWindow = urlParams.get('view') === 'display'
	const gridStyle = {
		fontSize: isDisplayWindow ? `${fontSize}px` : undefined,
	}

	return (
		<div
			className={`word-grid ${isDisplayWindow ? 'word-grid--display' : 'word-grid--control'} ${getModeClasses(hideWordMode, showWordMode)}`}
			style={gridStyle}
		>
			{lines?.map((line, lineIndex) => (
				<p key={`line-${lineIndex}`} className="word-grid-line">
					{line.map((word, wordIndex) => {
						const isVerseNumber = wordIndex === 0 && /\d+\./.test(word.text)
						return (
							<Word
								key={word.id}
								word={word}
								hideWordMode={hideWordMode}
								showWordMode={showWordMode}
								onToggle={onWordToggle}
								plain={isVerseNumber}
							/>
						)
					})}
				</p>
			))}
		</div>
	)
}

function getModeClasses(hideWordMode: HideWordMode, showWordMode: ShowWordMode) {
	const classes: string[] = []
	if (showWordMode == 'firstLetter' || showWordMode == 'word') classes.push('showmode-hidesymbol')
	// if (showWordMode == 'symbol') classes.push('showmode-hideword')
	if (hideWordMode != 'symbol' && hideWordMode != 'firstLetterEmoji') classes.push('hidemode-hidesymbol')
	if (hideWordMode != 'firstLetter' && hideWordMode != 'firstLetterEmoji') classes.push('hidemode-hideword')

	return classes.join(' ')
}
